const C = {
  name: "Diagnostics",
  dimensions: { width: 40, height: 41 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_27_2048)">
    <path d="M3 38.0029C2.45 38.0029 2 37.5529 2 37.0029V2.00293H37C37.55 2.00293 38 2.45293 38 3.00293V38.0029H3ZM38 0.00292969H2C0.9 0.00292969 0 0.90293 0 2.00293V38.0029C0 39.1029 0.9 40.0029 2 40.0029H38C39.1 40.0029 40 39.1029 40 38.0029V2.00293C40 0.90293 39.1 0.00292969 38 0.00292969Z" />
    <path d="M34 21.0029H26C25.62 21.0029 25.27 21.2229 25.1 21.5629L24.36 23.1029L20.98 7.78293C20.87 7.33293 20.47 7.00293 20 7.00293H19.99C19.52 7.00293 19.11 7.34293 19.02 7.80293L14.92 28.2929L11.97 15.7629C11.87 15.3229 11.49 15.0129 11.04 14.9929C10.59 14.9729 10.19 15.2529 10.05 15.6729L8.28 21.0029H6C5.45 21.0029 5 21.4529 5 22.0029C5 22.5529 5.45 23.0029 6 23.0029H9C9.43 23.0029 9.81 22.7229 9.95 22.3229L10.84 19.6629L14.03 33.2329C14.13 33.6829 14.54 34.0029 15 34.0029C15.01 34.0029 15.01 34.0029 15.02 34.0029C15.49 33.9929 15.89 33.6629 15.98 33.2029L20.05 12.8629L23.03 26.3429C23.12 26.7629 23.47 27.0729 23.89 27.1229C24.33 27.1729 24.72 26.9529 24.91 26.5629L26.63 23.0029H34C34.55 23.0029 35 22.5529 35 22.0029C35 21.4529 34.55 21.0029 34 21.0029Z" />
    </g>
    <defs>
    <clipPath id="clip0_27_2048">
    <rect width="40" height="40" fill="currentColor" transform="translate(0 0.00292969)"/>
    </clipPath>
    </defs>
    </svg>
  `
};
export {
  C as Diagnostics
};
